import React, { useEffect, useState } from "react";
import { Styles } from "../styles/courseSearch.js";

const CourseSearch = ({ onSearch, loading, totalResults, currentSearch }) => {
  const [searchValue, setSearchValue] = useState(currentSearch || "");

  useEffect(() => {
    setSearchValue(currentSearch || "");
  }, [currentSearch]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (typeof onSearch === "function") {
      onSearch(searchValue.trim());
    }
  };

  const handleClear = () => {
    setSearchValue("");
    if (typeof onSearch === "function") {
      onSearch("");
    }
  };

  const hasSearchValue = searchValue.trim().length > 0;
  const total = Number.isFinite(totalResults) ? totalResults : 0;
  const resultsLabel = loading
    ? "Searching courses..."
    : `${total} course${total === 1 ? "" : "s"} found`;

  return (
    <Styles>
      <div className="course-search">
        <h5>Search Course</h5>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="search"
            placeholder="Search "
            value={searchValue}
            onChange={(event) => setSearchValue(event.target.value)}
          />
          <button type="submit" disabled={loading}>
            <i
              className={`las ${loading ? "la-spinner la-spin" : "la-search"}`}
            ></i>
          </button>
        </form>
        <div className="search-meta">
          <small>{resultsLabel}</small>
          {hasSearchValue && !loading && (
            <button
              type="button"
              className="clear-search"
              onClick={handleClear}
            >
              Clear
            </button>
          )}
        </div>
      </div>
    </Styles>
  );
};

export default CourseSearch;
